export function* getOrder(ref) {
    let order = 0;

    const docs = yield ref.orderBy('order', 'desc').limit(1).get();

    if (!docs.empty && docs.docs[0]) {
        const lastDocInOrder = docs.docs[0].data();
        order = lastDocInOrder.order + 1;
    }

    return order;
}
